
import {
  computed, defineComponent, reactive,
} from 'vue';
import Card from '@/core/components/UI/Card.vue';
import Icone from '@/core/components/UI/Icone.vue';
import ManualPreenchimentoInspecao from '@/models/Constantes/ManualPreenchimentoInspecao';
import { IInspecaoSecao6 } from '@/models/Entidades/IInspecao';

export default defineComponent({
  name: 'InspecaoSecao6',
  props: {
    secao6: {
      type: Object as () =>IInspecaoSecao6,
      required: true,
    },
    bloquearCampos: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Card,
    Icone,
  },
  emits: ['update:secao6', 'change'],
  setup(props, { emit }) {
    const state = reactive({
      enviandoArquivos: false,
      excluindoArquivos: false,
      manuaisPreenchimento: {} as Record<string, boolean>,
    });

    const computedSecao6 = computed({
      get: () => props.secao6,
      set: (valor: IInspecaoSecao6) => {
        emit('update:secao6', valor);
      },
    });

    function change() {
      emit('change');
    }

    function alternarManualPreenchimento(chave: string) {
      state.manuaisPreenchimento[chave] = !state.manuaisPreenchimento[chave];
    }

    return {
      props,
      computedSecao6,
      state,
      change,
      ManualPreenchimentoInspecao,
      alternarManualPreenchimento,
    };
  },
});
